import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./FlightBooking')));
const ProductList = Loadable(lazy(() => import('./FlightList')));
// const EditPipeline = Loadable(lazy(() => import('./CustomerEdit')));
// const Trans = Loadable(lazy(() => import('./CustomerTransList')));

const FlightRoutes = [
	{
		path: '/flight/bookings',
		element: <Analytics />,
		auth: authRoles.admin,
	},
	{
		path: '/flight/list',
		element: <ProductList />,
		auth: authRoles.admin,
	},
	// {
	// 	path: '/customer/list/trans',
	// 	element: <Trans />,
	// 	auth: authRoles.admin,
	// },
	// {
	// 	path: '/customer/list/edit',
	// 	element: <EditPipeline />,
	// 	auth: authRoles.admin,
	// },
];

export default FlightRoutes;
